<template>
  <div>
    <v-toolbar flat class="cactus-primary--toolbar">
      <v-btn color="primary" @click="showCreateDialog = true">Create Cultures</v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout class="pa-4">
      <v-flex>
        <NoResults v-if="!items.length && !loading" icon="blur_circular" message="You have no cultures created. Press the create button above to get started."></NoResults>
          <CultureList v-if="items.length" :items="items" :actions="true">
            <template v-slot:actions="{item}">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" @click="markCulture = item">
                    <template v-if="item.status !== 'invalid'">not_interested</template>
                    <template v-else>settings_backup_restore</template>
                  </v-icon>
                </template>
                <span v-if="item.status === 'invalid'">Restore to valid</span>
                <span v-else>Mark Invalid</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" @click="deleteCulture(item)">
                    <template>delete</template>
                  </v-icon>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </template>
          </CultureList>
          <InfiniteLoading @infinite="scrollLoad" :identifier="infiniteLoaderId"></InfiniteLoading>
      </v-flex>
    </v-layout>
    <SetStatusDialog :item="markCulture" @close="markCulture = undefined" max-width="500px" persistent @save="saveCultureStatus">
      <template v-slot:info>
        <p v-if="markCulture">Updating culture ID: {{markCulture.culture_id}}</p>
      </template>
    </SetStatusDialog>
    <v-dialog v-model="showCreateDialog" persistent>
      <v-card>
        <v-toolbar flat color="transparent">
          <v-toolbar-title>Create Cultures</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showCreateDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <CultureCreateForm @add="processCreateCulture" :multiple-strains="true" flat></CultureCreateForm>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import CultureAPI from '@/api/culture.js'
import NoResults from '@/components/ui/noresults.vue'
import {mapState} from 'vuex'
import ExtractionMethodAPI from '@/api/extraction-method.js'
import CultureList from '@/components/culture/table--list-culture.vue'
import SetStatusDialog from '@/components/culture/dialog--set-status.vue'
import CultureCreateForm from './create-form.vue'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  components: {
    NoResults,
    CultureList,
    SetStatusDialog,
    CultureCreateForm,
    InfiniteLoading
  },
  data () {
    return {
      items: [],
      loading: false,
      markCulture: null,
      showCreateDialog: false,
      autoComplete: {
        extractionMethod: []
      },
      infiniteLoaderId: +new Date(),
      pagination: {
        perPage: 100,
        page: 0
      }
    }
  },
  computed: {
    ...mapState(['user']),
    cultureFilterParams () {
      /**
       * allows us to configure these parameters to the API say
       * grab different researchers, or different status
       */
      const filterParams = {
        status: {filter: 'is', value: 'null'}
      }
      return filterParams
    }
  },
  async created () {
    this.extractionMethodAPI = ExtractionMethodAPI
  },
  methods: {
    async loadAutocompletes () {
      /**
       * load and store commonly used auto completes to that
       * this page is not constantly loading them
       */
      const params = {
        limit: 500
      }
      const [extractionMethod] = await Promise.all([
        ExtractionMethodAPI.get({params})
      ])
      this.autoComplete.extractionMethod = extractionMethod.data
    },
    saveCultureStatus ({item, changes}) {
      /**
       * simply updates the state with
       * changes sent to the api
       */
      Object.assign(item, changes)
    },
    async processCreateCulture (payload) {
      /**
       * loop over the grouped cultures
       * and create appropriate culture
       * definittion for the culture API
       */
      const {mp, replicons} = payload
      const repeatRows = parseInt(replicons)
      console.log('culture payload', payload, mp)
      const culturesToAPI = []
      mp.taxonomy.forEach((taxonomy) => {
        // replicate rows per taxonomy
        mp.culture_medium.forEach((em) => {
          for (let i = 1; i <= repeatRows; i++) {
            const culture = {
              culture_id: undefined,
              taxonomy: taxonomy,
              organization: mp.organization,
              researcher: mp.researcher,
              culture_medium: em,
              experiment_class: mp.experiment_class,
              inoculation_date: mp.inoculation_date,
              fermentation_volume: mp.fermentation_volume,
              fermentation_temperature: mp.fermentation_temperature
            }
            culturesToAPI.push(culture)
          }
        })
      })
      await CultureAPI.create(culturesToAPI)
      this.showCreateDialog = false
      this.getCultures()
    },
    unnestGroupedCultures (data) {
      /**
       * the API sends everything grouped in an object
       * by innoculation date, then taxonomy, then culture
       * medium. Lets unnest this to just a list.
       */
      const cultures = []
      Object.keys(data).forEach((inocDate) => {
        Object.keys(data[inocDate]).forEach((tax) => {
          Object.keys(data[inocDate][tax]).forEach((cMed) => {
            cultures.push(...data[inocDate][tax][cMed])
          })
        })
      })
      return cultures
    },
    async getCultures ({extraParams = {}} = {}) {
      /**
       * API sends these keyd by date, then strain, culture medium. Unnest
       * this data
       */
      this.loading = true
      const params = {
        'select': '*,researcher(*),culture_medium(*),taxonomy(*),organization(*),experiment_class(*)',
        'order': 'culture_id.desc',
        ...extraParams
      }

      const {data} = await CultureAPI.get({params, filterParams: this.cultureFilterParams})
      this.loading = false
      return data
    },
    reload () {
      /**
       * a hacky way of grabbing new data
       * from the API and triggering inifiniteLoader
       * to pull from the api.
       */
      this.infiniteLoaderId += 1 // resets the infinite loader when filters change
      this.pagination.page = 0
      this.items = []
    },
    async scrollLoad ($state) {
      // $state from infinite-loader component
      const extraParams = {
        limit: this.pagination.perPage,
        offset: this.pagination.page * this.pagination.perPage
      }
      const data = await this.getCultures({extraParams})
      if (data.length) {
        this.items = [...this.items, ...data]
        this.pagination.page += 1
        $state.loaded()
      } else {
        $state.complete()
      }
    },
    async deleteCulture (culture) {
      if (confirm('Are you sure you want to delete this item?')) {
        await CultureAPI.delete(culture.culture_id)
        const idx = this.cultures.indexOf(culture)
        if (idx > -1) {
          this.cultures.splice(idx, 1)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
